import { useEffect } from 'react';
import { useEnvironment } from '../core/useEnvironment';

const deviceInsetProperties = [
  '--safe-area-inset-top',
  '--safe-area-inset-bottom',
  '--safe-area-inset-left',
  '--safe-area-inset-right',
];
const contentInsetProperties = [
  '--telegram-content-safe-area-inset-top',
  '--telegram-content-safe-area-inset-bottom',
  '--telegram-content-safe-area-inset-left',
  '--telegram-content-safe-area-inset-right',
];

export function useSafeArea() {
  const { isTelegram } = useEnvironment();

  useEffect(() => {
    if (!isTelegram || typeof window === 'undefined' || !window.Telegram?.WebApp) return;

    const webApp = window.Telegram.WebApp;
    const applySafeAreas = () => {
      const root = document.documentElement;
      const { safeAreaInset, contentSafeAreaInset } = webApp;

      if (safeAreaInset) {
        root.style.setProperty('--safe-area-inset-top', `${safeAreaInset.top}px`);
        root.style.setProperty('--safe-area-inset-bottom', `${safeAreaInset.bottom}px`);
        root.style.setProperty('--safe-area-inset-left', `${safeAreaInset.left}px`);
        root.style.setProperty('--safe-area-inset-right', `${safeAreaInset.right}px`);
      } else {
        deviceInsetProperties.forEach((property) => root.style.removeProperty(property));
      }
      if (contentSafeAreaInset) {
        root.style.setProperty(
          '--telegram-content-safe-area-inset-top',
          `${contentSafeAreaInset.top}px`
        );
        root.style.setProperty(
          '--telegram-content-safe-area-inset-bottom',
          `${contentSafeAreaInset.bottom}px`
        );
        root.style.setProperty(
          '--telegram-content-safe-area-inset-left',
          `${contentSafeAreaInset.left}px`
        );
        root.style.setProperty(
          '--telegram-content-safe-area-inset-right',
          `${contentSafeAreaInset.right}px`
        );
      } else {
        contentInsetProperties.forEach((property) => root.style.removeProperty(property));
      }
    };

    applySafeAreas();
    if (!webApp.isExpanded) webApp.expand();

    webApp.onEvent('viewportChanged', applySafeAreas);
    webApp.onEvent('safeAreaChanged', applySafeAreas);
    webApp.onEvent('contentSafeAreaChanged', applySafeAreas);

    return () => {
      webApp.offEvent('viewportChanged', applySafeAreas);
      webApp.offEvent('safeAreaChanged', applySafeAreas);
      webApp.offEvent('contentSafeAreaChanged', applySafeAreas);
      const root = document.documentElement;
      [...deviceInsetProperties, ...contentInsetProperties].forEach((property) =>
        root.style.removeProperty(property)
      );
    };
  }, [isTelegram]);
}
